// @flow

import type {EnforcementMode} from './types';

// TODO (nkohari): Determine the URL which will be used to determine enforcement mode
export const ENFORCEMENT_MODE_URL =
  'https://stripe.com/cookie-settings/enforcement-mode';

export const ENFORCEMENT_MODE_TIMEOUT_MS = 1000;

// TODO (nkohari): This disables the API call, because the endpoint doesn't exist yet.
// Re-enable this once it does.
const DISABLE = true;

let resolvedEnforcementModePromise: ?Promise<EnforcementMode> = null;

/**
 * Resolves the enforcement mode for the current user by making a fetch() call to the
 * IP geolocation endpoint.
 */
export const resolveEnforcementMode = (): Promise<EnforcementMode> => {
  if (!resolvedEnforcementModePromise) {
    const request = async () => {
      let mode: EnforcementMode = 'restricted';

      try {
        const response = await fetch(ENFORCEMENT_MODE_URL);
        const result = await response.json();
        if (result.mode === 'restricted' || result.mode === 'open') {
          mode = result.mode;
        }
      } catch (err) {
        // If we encounter an error when looking up the enforcement mode,
        // fail closed and default to "restricted".
      }

      return mode;
    };

    const timeout = () =>
      new Promise<EnforcementMode>((resolve, reject) => {
        // If the request times out, we should fail closed and default to "restricted".
        setTimeout(() => resolve('restricted'), ENFORCEMENT_MODE_TIMEOUT_MS);
      });

    if (DISABLE) {
      resolvedEnforcementModePromise = Promise.resolve('open');
    } else {
      resolvedEnforcementModePromise = Promise.race([request(), timeout()]);
    }
  }

  return resolvedEnforcementModePromise;
};

/**
 * Manually sets the resolved enforcement mode. This should only be used during testing.
 * @private
 */
export const setResolvedEnforcementMode = (mode: ?EnforcementMode) => {
  resolvedEnforcementModePromise = mode ? Promise.resolve(mode) : null;
};
